<script setup lang="ts">
import { RouterView } from 'vue-router'
import AppShell from './layouts/AppShell.vue'
import AuthWrapper from './services/AuthWrapper.vue'
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import DynamicToastProvider from './components/DynamicToastProvider.vue'

//Changing the lang attribute of the html element to match the current locale
const { locale } = useI18n()
document.documentElement.lang = locale.value
watch(locale, (newLang) => {
  document.documentElement.lang = newLang
})
</script>

<template>
  <AuthWrapper>
    <DynamicToastProvider>
      <AppShell>
        <RouterView v-slot="{ Component }">
          <component :is="Component" />
        </RouterView>
      </AppShell>
    </DynamicToastProvider>
  </AuthWrapper>
</template>

<style scoped></style>
